<template>
  <div
    v-bind:style="showModalAppointment ? {display: 'block'} : {display: 'none'}"
    class="modal"
    id="infoModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="display: none;"
  >
    <div class="modal-dialog modal-info modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Requerimiento #{{requeriment.id}} :: Cita</h4>
          <button
            @click="close"
            class="close"
            type="button"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <b-form>
            <b-row class="form-group">
              <b-col sm="5">
                <label for>Código</label>
                <input
                  type="text"
                  required
                  v-model="requeriment.appointment_code"
                  class="form-control"
                  style="text-transform: uppercase;"
                >
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col sm="5">
                <label for>Fecha - Hora cita</label>
                <date-picker
                  v-model="requeriment.appointment_date"
                  lang="es"
                  type="datetime"
                  required
                  format="DD/MM/YYYY HH:mm"
                  :time-picker-options="{ start: '00:00', step: '00:05', end: '23:55' }"
                ></date-picker>
              </b-col>
            </b-row>
          </b-form>
        </div>
        <div class="modal-footer">
          <button @click="saveAppointment()" type="button" class="btn btn-primary">Guardar</button>
          <button @click="close" type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";
import moment from "moment";
export default {
  name: "ModalAppointment",
  props: ["requeriment", "showModalAppointment"],
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    saveAppointment() {
      let data = {
        appointment_code: this.requeriment.appointment_code.toUpperCase(),
        appointment_date: moment(this.requeriment.appointment_date).format(
          "YYYY-MM-DD HH:mm:ss"
        )
      };

      api.put(`/requeriments/${this.requeriment.id}`, data).then(response => {
        if (response.success) {
          this.$toastr.success(`Cita registrada exitosamente`, "Porteo", {
            positionClass: "toast-top-center",
            closeButton: true
          });
          this.$socket.emit("updateRequerimentServer", response.requeriment);
          this.close(null, response.requeriment);
        }
      });
    },
    close(e, rq = null) {
      this.truckSelected = {};
      this.$emit("close", rq);
    }
  }
};
</script>
